const initGorgiasChatPromise = window.GorgiasChat
  ? window.GorgiasChat.init()
  : new Promise(function (resolve) {
      window.addEventListener('gorgias-widget-loaded', function () {
        resolve()
      })
    })

initGorgiasChatPromise.then(() => {
  const gorgiasButtons = document.querySelectorAll('.js-gorigas-open')
  gorgiasButtons.forEach(function (gorgiasButton) {
    gorgiasButton.addEventListener('click', function (event) {
      event.preventDefault()
      if (GorgiasChat.isOpen()) {
        GorgiasChat.close()
      } else {
        GorgiasChat.open()
      }
    })
  })
})
